import React from 'react';
import { authService } from 'AuthService';

import { MsalProvider } from '@azure/msal-react';

import AuthenticatedApp from './AuthenticatedApp';

const AuthenticatedAppWithMsal: React.FC = () => {
  return (
    <MsalProvider instance={authService.getPublicClientApplication()}>
      <AuthenticatedApp />
    </MsalProvider>
  );
};

export default AuthenticatedAppWithMsal;
